import type { IconData } from '@stacksjs/iconify-core'

export const alarm: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M256 80C141.125 80 48 173.125 48 288s93.125 208 208 208s208-93.125 208-208S370.875 80 256 80m124.451 332.451A176 176 0 1 1 432 288a174.85 174.85 0 0 1-51.549 124.451\"/><path fill=\"currentColor\" d=\"M272 160h-32v135.69l86.005 68.804l19.99-24.988L272 280.31zM22.965 114.796l152-104l18.071 26.411l-152 104zm296.002-77.59l18.07-26.41l152 104.002l-18.071 26.41z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default alarm
